import CurrencyInputField, { type CurrencyInputProps } from "react-currency-input-field";
import { Input } from "../../../ui/input";

export type NumberInputProps = Omit<CurrencyInputProps, "onValueChange" | "onChange"> & {
    onChange?: (value: number | undefined) => void;
};

function NumberInput({
    className,
    onChange,
    decimalsLimit = 2,
    allowNegativeValue = false,
    ...props
}: NumberInputProps) {
    return (
        <CurrencyInputField
            customInput={Input}
            className={className}
            decimalsLimit={decimalsLimit}
            allowNegativeValue={allowNegativeValue}
            onValueChange={(_value, _name, values) => onChange?.(values?.float ?? undefined)}
            {...props}
        />
    );
}

export default NumberInput;
